import { gql } from '@apollo/client';

const query = gql`
  query localsearchCMSCategories($categoryName: String!, $size: Int) {
    localsearchCMSCategories(categoryName: $categoryName, size: $size) {
      categories {
        name
        featureImage
      }
    }
  }
`;

module.exports = query;
